import React from 'react';
import { Button, CircularProgress } from '@worthy-npm/worthy-common-ui-components';

interface NextButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  children?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  sx?: Record<string, any>;
}

function NextButton({
  onClick,
  disabled = false,
  loading = false,
  children = 'Next',
  size = 'medium',
  sx,
}: NextButtonProps) {
  return (
    <Button
      size={size}
      disableElevation
      variant="contained"
      color="highlight"
      fullWidth
      sx={{
        minWidth: 190,
        width: { xs: '100%', sm: 'fit-content' },
        ...sx,
      }}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <CircularProgress size={24} /> : children}
    </Button>
  );
}

export default NextButton;
